import React, { FunctionComponent, memo } from "react";

type WarningIconProps = { className: string };

const Warning: FunctionComponent<WarningIconProps> = ({
  className,
}: WarningIconProps) => (
  <svg
    width="24"
    height="24"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9002 20H4.09977C2.48406 20 1.47686 18.2325 2.28471 16.8249L10.1849 3.05571C10.9928 1.6481 13.0072 1.6481 13.8151 3.05571L21.7153 16.8249C22.5231 18.2325 21.5159 20 19.9002 20ZM10.8458 12.3682C10.8458 12.9907 11.3651 13.5001 11.9999 13.5001C12.6346 13.5001 13.154 12.9907 13.154 12.3682V9.13185C13.154 8.50933 12.6346 8 11.9999 8C11.3651 8 10.8458 8.50933 10.8458 9.13185V12.3682ZM12.022 16.9378C12.6471 16.9378 13.1539 16.431 13.1539 15.8059C13.1539 15.1808 12.6471 14.6741 12.022 14.6741H11.9776C11.3525 14.6741 10.8457 15.1808 10.8457 15.8059C10.8457 16.431 11.3525 16.9378 11.9776 16.9378H12.022Z"
      fill="#F2CB00"
    />
  </svg>
);

export default memo(Warning);
